import { userRoles } from './UserRole'

import type { UserEmployeeTypeEnum } from 'gql/graphql'

const { admin, adops, backOffice, customerPerformance, customerSuccess } = userRoles

export type UserGroup = keyof typeof userGroupRoles
export type UserGroupRoles = typeof userGroupRoles

export const userGroupRoles = {
  employeesOnly: [admin, adops, backOffice, customerPerformance, customerSuccess],
} as const satisfies Record<string, readonly UserEmployeeTypeEnum[]>
